// Mock data for Legacy Motorplex Credit Application

export const companyInfo = {
  name: "Legacy Motorplex",
  phone: "(404) 723-1672",
  address: "2759 Delk Rd SE",
  city: "Marietta",
  state: "GA",
  zip: "30067",
  fullAddress: "2759 Delk Rd SE, Marietta, GA 30067",
  logo: "https://customer-assets.emergentagent.com/job_10b4ceb0-d9c8-4045-a436-a78269c5ca76/artifacts/uei4x93y_IMG_7484.jpeg"
};

export const vehicleMakes = [
  "Acura", "Audi", "BMW", "Buick", "Cadillac", "Chevrolet", "Chrysler",
  "Dodge", "Ford", "GMC", "Honda", "Hyundai", "Infiniti", "Jaguar",
  "Jeep", "Kia", "Land Rover", "Lexus", "Lincoln", "Mazda", "Mercedes-Benz",
  "Nissan", "Porsche", "Ram", "Subaru", "Tesla", "Toyota", "Volkswagen", "Volvo"
];

export const statesList = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];

export const employmentTypes = [
  "Full-Time",
  "Part-Time",
  "Self-Employed",
  "Retired",
  "Student",
  "Unemployed"
];

export const housingTypes = [
  "Own",
  "Rent",
  "Live with Family",
  "Other"
];

// Generate years for vehicle selection (last 30 years)
export const vehicleYears = Array.from({ length: 30 }, (_, i) => (new Date().getFullYear() + 1 - i).toString());
